module.exports = {"teacherdashboard":"Teacher","admindashboard":"School Admin"}


//////////////////
// WEBPACK FOOTER
// ./src/engTrans.json
// module id = 2503
// module chunks = 0